import { BlockType } from '../../types/index.js';
import { CardBlock as Component } from './Block.js';
export const RegisteredCardBlock = (_intl) => ({
    recommendedName: 'Card',
    Component,
    config: {
        type: BlockType.BuildingBlock,
    },
});
//# sourceMappingURL=registered.js.map